export default "__VITE_ASSET__PlpiNS0h__";